import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';

@Component({
  selector: 'app-home-redirect',
  template: '<div>Redirecting...</div>'
})
export class HomeRedirectComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit() {
    const homeUrl = this.authService.getHomeUrl();
    this.router.navigate([homeUrl]);
  }
}
